import React from 'react'
import {
  enableMyAccountsMFE,
  enableAccountProfileMFE,
  isAccountProfileDelegatedRoute,
  IS_BROWSER,
} from 'src/utils'
import MyAccount from '../MyAccount'
import MyAccountMFE, {
  ACCOUNT_PROFILE_SHELL_REMOTE_CONFIG,
} from '../MyAccountMFE'

class DynamicAccount extends React.Component {
  render() {
    // LATAM/PAC: whole /myaccount subtree served by the account-profile full-shell
    // MFE (sidebar + content). Bypasses the local shell + MyAccountMenu, so there
    // is no double sidebar. `includeCurrentPath` lets the Next.js shell derive the
    // active content page + nav highlight from the host URL on each navigation.
    if (enableAccountProfileMFE() && IS_BROWSER) {
      const path = this.props.history?.location?.pathname || ''
      // Delegated routes (e.g. Favorites): render storefront's OWN native content
      // (which already matches account-mfe and is market-safe) but with the NEW
      // account-profile side panel — instead of the full-shell MFE. Avoids porting
      // the catalog/ProductCard subsystem for these routes.
      if (isAccountProfileDelegatedRoute(path)) {
        return <MyAccount {...this.props} useAccountProfileSideMenu />
      }
      return (
        <MyAccountMFE
          {...this.props}
          remoteConfig={ACCOUNT_PROFILE_SHELL_REMOTE_CONFIG}
          includeCurrentPath
        />
      )
    }

    return (
      <>
        {enableMyAccountsMFE() && IS_BROWSER ? (
          <MyAccountMFE {...this.props} />
        ) : (
          <MyAccount {...this.props} />
        )}
      </>
    )
  }
}

export default DynamicAccount
export { DynamicAccount }
